import { OrganizationRoute } from "#routes/organization";
import { RoutePath } from "#utils/route";

export const NetworkListRoute = OrganizationRoute.concat(
  new RoutePath({
    path: "/networks",
    title: "asset_group_plural",
  })
);
